'use client'
import IFrameForm from './IFrameForm'
import withFormProviders from '@/donationPages/_dependencies/components/withFormProviders'
const IFrameFormWithProviders = withFormProviders(IFrameForm)
export default IFrameFormWithProviders
